import React, { useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../Appstore/store";
import {
  AddSmsCampaignsShortcuts,
  GetallSmsCampaignShortcuts,
} from "../Features/SmscampaignShortcuts/Smscampaignshortcuts";
import { Button, Modal } from "react-bootstrap";
import { toast } from "sonner";

interface SmsCampaignShortcutsAdd {
  code: string;
  message: string;
  id?: number;
  sms_campaign_id?: number;
}

interface AddsmscampaignshortcutsmodalProps {
  show: boolean;
  onHide: () => void;
  recordid: number;
}

const Addsmscampaignshortcuts: React.FC<AddsmscampaignshortcutsmodalProps> = ({
  show,
  onHide,
  recordid,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { id }: any = useParams();

  const { error, smscampaignshortcutsdata, loading } = useSelector(
    (state: RootState) => state.smscampaignshortcuts
  );
  // const record: SmsCampaignShortcutsAdd | any = smscampaignshortcutsdata.find(recodID => recodID.id === Number(id));

  const validationSchema = Yup.object({
    code: Yup.string()
      .required("Code is required")
      .trim()
      .matches(
        /^[^#]+$/,
        "Code cannot contain the # symbol and # symbol is your start with by default set"
      )
      .matches(/^\S+$/, "Code cannot contain spaces"),

    message: Yup.string().required("Message is required").trim(),
  });

  const initialValues = {
    code: "",
    message: "",
  };

  useEffect(() => {
    const defaultPage = 1;
    const defaultLimit = 10;
    dispatch(
      GetallSmsCampaignShortcuts({
        search: "",
        page: defaultPage,
        limit: defaultLimit,
        sms_campaign_id: recordid,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      toast.error(
        error || "An error occurred while adding the Sms campaign shortcuts"
      );
    }
  }, [error]);

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Add Sms Campaign Shortcuts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
              const SmsCampaignShortcutsData: SmsCampaignShortcutsAdd = {
                code: values.code.startsWith("#")
                  ? values.code
                  : `#${values.code}`,
                message: values.message,
                sms_campaign_id: recordid,
              };

              try {
                const response: any = await dispatch(
                  AddSmsCampaignsShortcuts(SmsCampaignShortcutsData)
                );
                dispatch(
                  GetallSmsCampaignShortcuts({
                    search: "",
                    page: 1,
                    limit: 10,
                    sms_campaign_id: recordid,
                  })
                );
                if (response.payload && response.payload.status === "success") {
                  toast.success(
                    response.payload.message ||
                      "Sms campaign shortcuts added successfully!"
                  );
                  resetForm();
                  onHide();
                } else if (response.payload?.status === "error") {
                  const backendErrorMessage =
                    response.payload.message || "Invalid credentials";
                  toast.error(backendErrorMessage);
                }
              } catch (err: any) {
                const errorMessage =
                  err.message || "An unexpected error occurred";
                toast.error(errorMessage);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ errors, touched, handleChange, values, isSubmitting }) => (
              <Form>
                <div className="form-group mb-3">
                  <label htmlFor="code">
                    Code<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">#</span>
                    </div>
                    <Field
                      type="text"
                      className={`form-control shadow-none ${
                        touched.code && errors.code
                          ? "is-invalid rounded-end-2"
                          : ""
                      }`}
                      id="code"
                      name="code"
                      placeholder="Enter a Code"
                    />
                    {touched.code && errors.code ? (
                      <div className="invalid-feedback">{errors.code}</div>
                    ) : null}
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="message">
                    Message<span className="text-danger">*</span>
                  </label>
                  <Field
                    as="textarea"
                    className={`form-control shadow-none ${
                      touched.message && errors.message ? "is-invalid" : ""
                    }`}
                    id="message"
                    name="message"
                    placeholder="Enter a Message"
                    rows="4"
                  />
                  {touched.message && errors.message ? (
                    <div className="invalid-feedback">{errors.message}</div>
                  ) : null}
                </div>

                <Modal.Footer className="d-flex justify-content-center border-0">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="ps-2">Submitting...</span>
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                  <Button
                    style={{ width: 75.5 }}
                    variant="secondary"
                    onClick={onHide}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Addsmscampaignshortcuts;
